import { render, staticRenderFns } from "./FormularioShow.vue?vue&type=template&id=6ce5f7e5&scoped=true&"
import script from "./FormularioShow.vue?vue&type=script&lang=js&"
export * from "./FormularioShow.vue?vue&type=script&lang=js&"
import style0 from "./FormularioShow.vue?vue&type=style&index=0&id=6ce5f7e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce5f7e5",
  null
  
)

export default component.exports